"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {
      backgroundColor: 'white',
      width: 325,
      transition: theme.transitions.create(['border-color']),
      '&.outline': {
        border: "1px solid ".concat(theme.palette.primary.icon)
      },
      '&.full-width': {
        width: 'unset'
      },
      '&.rounded': {
        borderRadius: '21px'
      },
      '&.squared': {
        borderRadius: '2px'
      },
      '&:hover, &:focus': {
        borderColor: theme.palette.secondary.navIcon
      },
      'label + &': {
        marginTop: '24.25px'
      }
    },
    input: {
      backgroundColor: theme.palette.common.white,
      // Ternary required for tests to function without error.
      fontSize: theme.typography.textField ? theme.typography.textField.fontSize : 14,
      lineHeight: theme.typography.textField ? theme.typography.textField.lineHeight : '20px',
      paddingLeft: '14.5px',
      paddingTop: '12px',
      paddingBottom: '12px',
      color: theme.palette.primary.main,
      '&.rounded': {
        borderRadius: '21px'
      },
      '&.squared': {
        borderRadius: '2px'
      },
      '&.icon-left': {
        paddingLeft: '8px'
      }
    },
    disabled: {
      backgroundColor: theme.palette.primary.disabled,
      color: theme.palette.primary.icon,
      '&:hover, &:focus': {
        borderColor: theme.palette.primary.icon
      }
    },
    error: {
      border: "1px solid ".concat(theme.palette.error.main),
      '&:hover, &:focus': {
        borderColor: theme.palette.error.main
      }
    },
    inputLabel: {
      color: theme.palette.primary.main
    },
    inputLabelTypography: {
      /**
       * The fontSize attribute must be 4/3 the fontSize of caption.
       * Why? Somewhere the fontSize of label is getting made 0.75*fontSize.
       * This is a workaround (so therefore not ideal).
       */
      fontSize: "".concat(theme.typography.caption.fontSize / 0.75, "px")
    },
    clear: {
      cursor: 'pointer'
    },
    errorText: {
      marginTop: '2.5px'
    },
    icon: {
      fill: theme.palette.primary.icon,
      '&.close': {
        '&:hover': {
          fill: theme.palette.secondary.navIcon
        }
      }
    }
  };
};

exports.default = _default;